import React, { createContext, Dispatch, useContext, useEffect, useReducer, useRef } from 'react'

import { currentSupportFiltersKey, InitialFilterState } from './filters.data'
import { FilterReducer } from './filters.reducer'
import { FiltersContextState } from './filters.type'

export const FiltersContextStore = createContext<FiltersContextState>({ ...InitialFilterState })

export const DispatchContext = createContext<
  Dispatch<{
    type: string
  }>
>(() => void 0)

export const FiltersContextProvider = ({
  children,
  value = InitialFilterState,
}: {
  children: React.ReactNode
  value?: FiltersContextState
}) => {
  const [state, dispatch] = useReducer(FilterReducer, value)

  // Use ref to access current state in event handler without re-registering listener
  const stateRef = useRef(state)
  stateRef.current = state

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        localStorage.setItem(currentSupportFiltersKey, JSON.stringify(stateRef.current))
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return (
    <DispatchContext.Provider value={dispatch}>
      <FiltersContextStore.Provider value={state}>{children}</FiltersContextStore.Provider>
    </DispatchContext.Provider>
  )
}

export function useFiltersContext(): [
  FiltersContextState,
  Dispatch<{
    type: string
  }>,
] {
  const ctx = useContext(FiltersContextStore)
  const dispatch = useContext(DispatchContext)
  return [ctx, dispatch]
}
